'use strict';
/**
 * @public getRecommendationTemplate
 * @param {JSON} recommendation - A recommendation Object
 *
 * @description
 * @returns recommendation template string
 */
function getRecommendationTemplate(recommendation, url, resource) {
    try {
        let image = recommendation.images.small[0];
        let gtmEventInputs = [];
        Object.keys(recommendation.gtmEvents).forEach(function (gtmEventName) {
            const encodedEventData = JSON.stringify(recommendation.gtmEvents[gtmEventName])
                .replace(/&/g, '&amp;')
                .replace(/"/g, '&quot;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
            gtmEventInputs.push(`<input type="hidden" name="${gtmEventName}" value="${encodedEventData}"/>`);
        });
        return `<div class="product-carousel__item product-cross-sell__item col-12 col-md-4 js-product-cross-sell-item">
                <div class="product js-product" data-pid="${recommendation.id}">
                    <div class="product-tile js-productTile" itemscope="" itemtype="http://schema.org/Product">
                        <div class="row align-items-center align-items-md-start">
                            <div class="col-3 col-md-5 pr-0">
                                <div class="product-tile__image__container img-container js-product-tile-image-container" data-pid="${recommendation.id}" data-image="${image.url}">
                                    <a href="${recommendation.selectedProductUrl}" class="js-product-tile-link" tabindex="0">
                                        <picture>
                                            <img class="product-tile__image js-product-tile-image lazyloaded" src="${image.url}" alt="${image.alt}" title="${image.title}" itemprop="image">
                                        </picture>
                                    </a>
                                </div>
                            </div>
                            <div class="col col-md-7">
                                <div class="tile-body">
                                    <div class="product-tile__name my-2 js-product-tile-name" itemprop="name">
                                        <div class="product-tile__brand mb-md-1">${recommendation.brand}</div>
                                        <a class="link product-tile__name d-block js-product-tile-link mb-md-1" href="${recommendation.selectedProductUrl}" itemprop="url" tabindex="0">
                                            ${recommendation.productName}
                                        </a>
                                    </div>

                                    <div class="price" itemprop="offers" itemscope="" itemtype="http://schema.org/Offer">
                                        <span>
                                            <meta itemprop="priceCurrency" content="EUR">
                                            ${recommendation.price.list ? `
                                                <span class="strike-through list">
                                                    <span class="value" itemprop="price" content="${recommendation.price.list.value}">${recommendation.price.list.formatted}</span>
                                                </span>
                                            ` : ''}
                                            <span class="sales">
                                                <span class="value" itemprop="price" content="${recommendation.price.sales.value}">${recommendation.price.sales.formatted}</span>
                                            </span>
                                        </span>
                                    </div>

                                    ${recommendation.variationAttributes.length > 0 ? `<div class="product-attribute">
                                        ${recommendation.variationAttributes.map(attribute => `<div>${attribute.displayName}: ${attribute.selectedValue}</div>`).join('')}
                                        </div>` : ''}
                                </div>
                            </div>
                            <div class="col-auto col-md-12 mt-4 pl-0 pl-md-3 align-items-center">
                                <div class="row">
                                    <div class="col text-success small d-none d-md-block pr-0">
                                        <div class="product-detail__shipping-message js-shipping-message mb-3">
                                            ${recommendation.shippingMessage}
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <div class="product-tile__addtocart">
                                            <button class="add-to-cart js-add-to-cart btn btn-primary btn-icon" data-pid="${recommendation.id}" data-url="${url}" tabindex="0">
                                                <span class="icon icon--shopping-cart-add"></span>
                                            </button>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="product-added__container">
                        <div class="d-flex align-items-center justify-content-center h-100">
                            <div class="d-inline-block border bg-white p-3">
                                <div class="product-added__label">
                                    <span class="icon icon--check pr-2"></span>
                                    <span>${resource}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                ${gtmEventInputs.join('\n')}
            </div>

        </div>`;
    } catch (error) {
        console.error('Failed to complere cross sell recommendation template.');
        console.error(error);
        return '';
    }
}

module.exports = getRecommendationTemplate;
